/***************************************************************************************************
** slice
** slice({ a: 1, b: 2, c: 3 }, ['a', 'b']) => { a: 1, b: 2 }
***************************************************************************************************/

export default function slice(object = {}, keys = [], options = {}) {
  return keys.reduce((accumulator, key) => {
    if (!options.compactify || ((object[key] !== undefined) && (object[key] !== null))) {
      accumulator[key] = object[key];
    }
    return accumulator;
  }, {});
}
